import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { addCommas } from '../../../utils/utils';
import { isFreePlan, isEnabledSendLetter, isEnabledExportExecutiveList, getPlanName, getMaxSendLetterCount, getMaxExportCount } from '../../../utils/planUtils';
import SectionHead from '../../common/SectionHead';
import PlanDialog from '../../SendLetter/dialogs/PlanDialog';

const double = 2;
const triple = 3;
const styles = theme => ({
  container: {
    width: '100%',
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing.unit * triple,
    marginBottom: "0px",
    padding: theme.spacing.unit * double,
  },

  flex: {
    flex: 1,
  },

  bold: {
    fontWeight: 700,
  },

  subheading: {
    fontSize: "13px",
    fontWeight: 700,
  },

  caption: {
    fontSize: "11px",
  },

  plan: {
    margin: "24px 0px",
    padding: "16px 8px",
  },

  activities: {
    marginTop: '10px',
    fontSize: '13px',
    color: '#71737B',
    whiteSpace: 'pre',
  },

  button: {
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    borderRadius: '2px',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  btnDisabled: {
    borderRadius: '2px',
    boxSizing: 'border-box',
    color: '#B1B3B9',
    border: '1px solid #E7E9EB',
    backgroundColor: '#F0F2F4',
  },
});

class PlanPanel extends React.Component {
  state = {
    showChangePlanDialog: false,
  }

  toggleChangePlanDialog = () => {
    this.setState({ showChangePlanDialog: !this.state.showChangePlanDialog });
  }

  renderActivities = () => {
    const { classes, user } = this.props;

    if (isFreePlan(user) || !user) {
      return null;
    }

    let text = '';

    if (isEnabledExportExecutiveList(user)) {
      text += `現在のプランでは${addCommas(user.active_plan_export_count)}` + ((getMaxExportCount(user) < Infinity) ? `/${addCommas(getMaxExportCount(user))}` : "") + `件ダウンロードしています。\n`;
    }
    text += `今までの総ダウンロード数は${addCommas(user.total_export_count)}件です。\n`;

    if (isEnabledSendLetter(user)) {
      text += `現在のプランでは${addCommas(user.active_plan_letter_count)}` + ((getMaxSendLetterCount(user) < Infinity) ? `/${addCommas(getMaxSendLetterCount(user))}` : "") + `通送付しています。\n`;
    }
    text += `今までの総通数は${addCommas(user.total_letter_count)}通です。\n`;

    return (
      <Typography variant="caption" className={classes.activities}>
        {text}
      </Typography>
    );
  }

  renderCurrentPlan = () => {
    const { classes, user } = this.props;

    return (
      <div>
        <SectionHead title="現在のプラン" />
        <div className={classNames(classes.row, classes.plan)}>
          <div className={classes.flex}>
            <Typography className={classes.bold} variant="subheading">{getPlanName(user)}</Typography>
            {this.renderActivities()}
          </div>
          <Button
            color="primary"
            className={user ? classes.button : classes.btnDisabled}
            onClick={this.toggleChangePlanDialog}
            disabled={!user}
          >
            プランを変更
          </Button>
        </div>
      </div>
    )
  }

  renderChangePlanDialog = () => {
    // 全ユーザーがKeymanLetter扱いのためPlanDialogを表示
    return (
      <PlanDialog
        isOpen={this.state.showChangePlanDialog}
        toggleDialog={this.toggleChangePlanDialog}
        isPlanUpdate={true} // 価格改定によりダイアログ差し替えのため追加した要素なので価格改定後に削除する
      />
    )
  }

  render() {
    const { classes } = this.props;

    let changePlanDialog;
    if (this.state.showChangePlanDialog) { changePlanDialog = this.renderChangePlanDialog(); }

    return (
      <div className={classes.container}>
        {this.renderCurrentPlan()}
        {changePlanDialog}
      </div>
    );
  }
}

PlanPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
};

export default withStyles(styles)(PlanPanel);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Plan/PlanPanel.jsx